<div class="loading-timer-container">
  <div>Загрузка...</div>
  <div>{{ timerValue }}.{{ milliseconds % 1000 | number: '3.0' }} сек.</div>
  <p-button label="Прервать" severity="danger" (click)="stopLoading()" />
</div>
